import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotasFiscaisComponent } from './notas-fiscais.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from '@po-ui/ng-templates';
import { NotasFiscaisEditComponent } from './notas-fiscais-edit/notas-fiscais-edit.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PoModule,
    PoPageDynamicTableModule,
    PoPageDynamicEditModule,
  ],
  declarations: [NotasFiscaisComponent, NotasFiscaisEditComponent]
})
export class NotasFiscaisModule { }
